var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{staticClass:"flex align-center checkbox-form",class:_vm.additionalClasses},[_c('input',{attrs:{"type":"checkbox","name":"pay-full-amout","id":"pay-full-amout"}}),_c('label',{staticClass:"small-font-bold",class:_vm.additionalClasses,attrs:{"for":"pay-full-amout"},on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }